import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const NEUROLOGIC_FORM_INITIAL_VALUES = {
  sections: {
    neurologic: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamNeurologicSections = keyof typeof NEUROLOGIC_FORM_INITIAL_VALUES.sections;
